import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const VisitsFilled: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 16)} fill="none">
            <Path
                d="M3 2C3 1.44772 3.44772 1 4 1C4.55228 1 5 1.44772 5 2V3H11V2C11 1.44772 11.4477 1 12 1C12.5523 1 13 1.44772 13 2V3H13.4872C14.322 3 14.998 3.57796 14.998 4.2917V5L1 5V4.2917C1 3.57796 1.67597 3 2.51076 3H3V2Z"
                fill={props.color}
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 6L14.998 6V13.5894C14.998 14.3686 14.3221 14.9996 13.4874 14.9996H2.51054C1.67588 14.9996 1 14.3667 1 13.5875V6ZM3 9V7H5V9H3ZM3 13V11H5V13H3ZM9 7H7V9H9V7ZM7 11H9V13H7V11ZM13 9V7H11V9H13ZM11 13V11H13V13H11Z"
                fill={props.color}
            />
        </Svg>
    );
};

export default React.memo(VisitsFilled);
